import { useTheme, Box, Typography } from '@mui/material';
import { tokens } from '../../../global/theme/tokens';
import MoneyLabel from '../../label/MoneyLabel';
import SpeedDialMenu from '../../menu/SpeedDialMenu';
import { useTranslation } from 'react-i18next';
import UserStack from '../UserStack';

const EmployeeClass = ({ empClass, showIcon, actions }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const { t } = useTranslation();

  return (
    <Box
      className="relative flex p-2 items-start gap-2 h-[90px]"
      sx={{
        backgroundColor: colors.bgInput,
        borderRadius: 4,
        borderLeft: `10px solid ${empClass.color}`,
        borderRight: '0px solid transparent',
      }}
    >
      {showIcon && empClass.image && (
        <img
          className="w-[32px] h-[32px] object-contain"
          src={empClass.image.temporaryUrl}
        />
      )}
      <Box className="w-full">
        <Typography fontWeight={600}>{empClass.label}</Typography>
        <Box className="flex justify-between gap-2">
          <Typography>{`${t('Hourly Rate')}`}</Typography>
          <Typography>
            <MoneyLabel money={empClass.wage} />
          </Typography>
        </Box>
        <Box className="flex justify-start h-[5px] pt-1">
          <UserStack users={empClass.users || []} />
        </Box>
      </Box>
      {actions && (
        <>
          <Box className="w-[40px]" />
          <SpeedDialMenu
            key={'SpeedDialMenuEmpClass' + empClass.id}
            className="absolute right-0 top-0"
            actions={actions}
          />
        </>
      )}
    </Box>
  );
};

export default EmployeeClass;
